import { render, staticRenderFns } from "./add_news.vue?vue&type=template&id=8b21a93c&scoped=true&"
import script from "./add_news.vue?vue&type=script&lang=js&"
export * from "./add_news.vue?vue&type=script&lang=js&"
import style0 from "./add_news.vue?vue&type=style&index=0&id=8b21a93c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b21a93c",
  null
  
)

export default component.exports